import PropTypes from 'prop-types';

const nullableString = PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]);

const baseBalancePropTypes = {
  periodName: PropTypes.string.isRequired,
  companyCode: PropTypes.string.isRequired,
  glAccount: nullableString,
  tradingPartner: PropTypes.string.isRequired,
  countryTax: PropTypes.string.isRequired,
  taxYear: PropTypes.string.isRequired,
  slAccount: PropTypes.string.isRequired,
  currencyCode: PropTypes.string.isRequired,
  bookType: PropTypes.string.isRequired,
  slBalance: PropTypes.number.isRequired,
};

const businessBalancePropTypes = PropTypes.shape({
  ...baseBalancePropTypes,
  businessCode: PropTypes.string.isRequired,
});

const connectionBalancePropTypes = PropTypes.shape({
  ...baseBalancePropTypes,
  connName: PropTypes.string.isRequired,
});

export const balancePropTypes = PropTypes.oneOfType([businessBalancePropTypes, connectionBalancePropTypes]);

export const groupTypePropTypes = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  }),
]);
export const groupTypesForSelectPropTypes = PropTypes.arrayOf(groupTypePropTypes);

export const slAccountPropTypes = PropTypes.shape({
  label: PropTypes.string,
  value: PropTypes.string,
});
export const slAccountsForSelectPropTypes = PropTypes.arrayOf(slAccountPropTypes);

export const accountBalancePropTypes = PropTypes.shape({
  periodName: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  slAccount: PropTypes.string.isRequired,
  slAccountDesc: PropTypes.string.isRequired,
  glAccount: nullableString,
  tradingPartner: PropTypes.string.isRequired,
  countryTaxType: PropTypes.string.isRequired,
  taxYear: PropTypes.string.isRequired,
  currencyCode: PropTypes.string.isRequired,
  bookType: PropTypes.string.isRequired,
  slBalance: PropTypes.number.isRequired,
}).isRequired;
export const accountBalancesPropTypes = PropTypes.arrayOf(accountBalancePropTypes).isRequired;
